import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';
import { useDiscoverCover } from '../shared/use-discover-cover';
import { useDiscoverTitle } from '../shared/use-discover-title';
import { useDiscoverDescV2 } from '../shared/use-discover-desc';

export const DiscoverTwitter = () => {
  const twitterCardInfo = {
    twCardTitle: useDiscoverTitle(),
    twCardDesc: useDiscoverDescV2(),
    twCardImageSrc: useDiscoverCover()?.url || '',
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
